import styled, { css } from 'styled-components';
import { Wrapper } from 'AppReact';

const template = styled.div`
  ${({ theme, displayState }) => css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 42px;
    border: 1px solid ${displayState?.error ? '#FD2020' : displayState?.focused ? theme?.colour?.primary ?? "#1DBD6B" : '#E3E3E3'};
    border-radius: 8px;
    padding-left: 12px;
    padding-right: 12px;
    
    &:hover {
      border: ${(displayState?.disabled || displayState?.error) ? '' : `1px solid ${theme?.colour?.primary ?? "#1DBD6B"}`};
    }
  `}
`;

export default Wrapper(template);